module.exports = __webpack_public_path__ + "static/media/LG 14_18sec.4467b0f2.mp3";